import { Spinner } from "@nextui-org/react";
import type { ReactNode } from "react";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import AnonymousMarketing from "@/pages/AnonymousMarketing/AnonymousMarketing";
import useAuth from "@/services/useAuth";

import FavoritesLorebooks from "./FavoritesLorebooks";

export default function FavoritesLorebooksPage() {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();

  let pageContent: ReactNode;
  if (isAuthLoading) {
    pageContent = <Spinner />;
  } else if (!isAuthenticated) {
    pageContent = <AnonymousMarketing datakey="favoritesLorebooks" />;
  } else {
    pageContent = <FavoritesLorebooks />;
  }

  return (
    <>
      <PageStaticMetaTags pageId="favoritesLorebooks" data-testid="FavoritesLorebooks-PageStaticMetaTags" />
      {pageContent}
    </>
  );
}
